module.exports = __webpack_public_path__ + "static/media/fye.00161947.png";